<template>
  <div class="meet_list">
  <el-table :data="meetList" border style="width: 100%;" :cell-style="getRowClass" :header-cell-style="getCellClass">
   <el-table-column prop="title" label="主题" min-width="120" :show-overflow-tooltip="true">
    </el-table-column>
   <el-table-column prop="typeDesc" label="类型" width="80" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间" width="140" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间" width="140" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="leader" label="发起人" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.leader.nameZh}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stage" label="阶段" width="80" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="140" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="creator" label="创建人" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.creator.nameZh}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="meetDetaile(scope.row,true)" type="text" size="small">查看</el-button>
          <el-button v-if="scope.row.creator.nameEn === username" @click="meetDetaile(scope.row,false)" type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
  </el-table>
  <AddMeet v-if="dialogVisibleMeet" :isedit="isedit" :checkDataInfo="checkDataInfo" :demandId="demandId" :dialogVisible='dialogVisibleMeet' :hideDialogVisible="handleMeetClose"/>
  </div>
</template>
<script>
import AddMeet from "@/views/tops/devOps/producerSpace/components/meeting/addMeet.vue";
import {
  getDevOpsSpaceMeetListApi,
  getDevOpsSpaceReportTaskListApi,
  postDevOpsSpaceDeleteTaskApi
} from "@/server/tops/devOps";
export default {
  components:{
    AddMeet
  },
  props:{
  demandId:{
    default: '',
  },
    meetList: {
    type:Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisibleMeet: false,
      checkDataInfo: {},
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
      },
      tableData: [],
      isedit: false,
      username: '',
    }
  },
  created() {
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.username = username;
    //this.getMeetList();
  },
  methods: {
    getMeetList(){
      getDevOpsSpaceMeetListApi({demandId: this.demandId}).then((res)=>{
        this.tableData = res.data;
      });
    },
    async change(){
      this.getMeetList();
    },
    // 关闭编辑弹窗
    handleMeetClose() {
      this.dialogVisibleMeet = false;
      //this.getMeetList();
      this.$emit('change');
    },
    meetDetaile(row,isedit) {
      this.checkDataInfo = row;
      this.isedit = isedit;
      this.dialogVisibleMeet = true;
    },
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "font-size: 12px;padding:6px 0;";
    },
    meetDelete(row) {
      this.$confirm("此操作将删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'meet' + row.id, true)
        try {
          /*const res = await postDevOpsSpaceDeleteTaskApi({
            id: row.id,
          });
          if (res.status === "success") {
            this.queryTaskList(this.form.id)
          } else {
            this.$notify({
              message: res?.data?.msg || "删除失败",
              type: "error",
            })
          }*/
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['meet' + row.id] = false;
        }
      });
    },
  },
}
</script>
<style>
.meet_list {
  max-height: 275px;
  overflow-y: auto;
  white-space: pre-wrap;
  /* background: #f1fbec; */
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.meet_list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.meet_list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
  rgba(255, 255, 255, 0.2) 25%,
  transparent 25%,
  transparent 50%,
  rgba(255, 255, 255, 0.2) 50%,
  rgba(255, 255, 255, 0.2) 75%,
  transparent 75%,
  transparent);
}

.meet_list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
</style>
